
          import { defineNuxtPlugin } from "#imports";

          export default defineNuxtPlugin({
            name: 'sentry-client-config',
            async setup() {
              await import("/opt/teamcity/buildAgent/work/984757540e73c1d/sentry.client.config.ts")
            }
          });